import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneInput.scss';
import clsx from 'clsx';
import CheckMark from './CheckMark';

import { isPhoneValid } from '../../utils/phoneNumber';

export const normalizePhoneNumber = (phone, countryCode) => {
  if (!phone) return phone;
  let normalized = phone;

  if (normalized.startsWith('+')) {
    normalized = normalized.slice(1);
  }

  if (normalized.startsWith('0') && countryCode === 'fr') {
    normalized = '33' + normalized.slice(1);
  }

  if (normalized.startsWith('3333')) {
    normalized = '33' + normalized.slice(4);
  }

  if (normalized.startsWith('330')) {
    normalized = '33' + normalized.slice(3);
  }

  if (normalized.startsWith('33') && normalized.length > 11) {
    normalized = normalized.slice(0, 11);
  }

  return normalized;
};

export const PhoneInputComponent = (
  {
    value,
    onChange,
    defaultCountry,
    onFocus,
    onBlur,
    isValid = true,
    displayCheckMark,
    onlyFrenchNumbers = false,
    onValidationChange,
    disabled = false,
  }) => {

  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (value && value.startsWith('0') && value.length >= 10 && onChange) {
      const normalized = normalizePhoneNumber(value, 'fr');
      onChange(normalized, { countryCode: 'fr' }, null, '');
    }
  }, [value, onChange]);

  useEffect(() => {
    if (onValidationChange && onlyFrenchNumbers) {
      const valid = isPhoneValid(value);
      onValidationChange(valid);
    }
  }, [value, onValidationChange, onlyFrenchNumbers]);

  const handlePhoneChange = (phone, data, e, formattedValue) => {
    if (!onChange) return;

    const normalizedPhone = normalizePhoneNumber(phone, data?.countryCode);


    if (normalizedPhone === value) {
      if (isPhoneValid(value)) {
        setResetKey((k) => k + 1);
      }
      return;
    }

    onChange(normalizedPhone, data, e, formattedValue);
  };

  return (
    <div className="flex items-center relative w-full mt-2">
      <PhoneInput
        key={resetKey}
        inputProps={{
          name: 'phone-number-input-drawer',
          disabled: disabled,
          onKeyDown: (e) => {
            if (isPhoneValid(value) && /^[0-9]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          onPaste: (e) => {
            if (isPhoneValid(value)) {
              e.preventDefault();
            }
          },
        }}
        value={value}
        onChange={handlePhoneChange}
        country={onlyFrenchNumbers ? 'fr' : (defaultCountry || 'fr')}
        countryCodeEditable={false}
        onlyCountries={onlyFrenchNumbers ? ['fr'] : undefined}
        disableDropdown={onlyFrenchNumbers || disabled}
        containerClass="phone-input-container"
        enableLongNumbers={true}
        inputClass={clsx('phone-input-field', { 'invalid': !isValid })}
        buttonClass="phone-input-button"
        dropdownClass="phone-input-dropdown"
        containerStyle={{
          width: '100%',
        }}
        inputStyle={{
          width: '100%',
          height: '64px',
          fontSize: '16px',
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          fontFamily: 'inherit',
          backgroundColor: disabled ? '#f5f5f5' : 'white',
          cursor: disabled ? 'not-allowed' : 'text',
          opacity: disabled ? 0.6 : 1,
        }}
        buttonStyle={{
          border: '1px solid #e0e0e0',
          borderRadius: '8px 0 0 8px',
          backgroundColor: disabled ? '#f5f5f5' : 'white',
          height: '56px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
        onFocus={onFocus}
        onBlur={onBlur}
        dropdownStyle={{
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}
      />

      <CheckMark show={displayCheckMark} />
    </div>

  );
};
